import React from "react";
import { State } from "../util/useState2";

export interface DebugContextProps {
    displayExtendedProductInfo: boolean;
}

export const DebugContext = React.createContext<State<DebugContextProps>>({
    value: {
        displayExtendedProductInfo: false,
    },
    set: () => { throw new Error("This debug context does not work"); }
});


